/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseActivityPage } from './CaseActivityPage';
import {
    CaseActivityPageFromJSON,
    CaseActivityPageFromJSONTyped,
    CaseActivityPageToJSON,
    CaseActivityPageToJSONTyped,
} from './CaseActivityPage';

/**
 * 
 * @export
 * @interface CaseActivityPageResponse
 */
export interface CaseActivityPageResponse {
    /**
     * 
     */
    data: CaseActivityPage;
}

/**
 * Check if a given object implements the CaseActivityPageResponse interface.
 */
export function instanceOfCaseActivityPageResponse(value: object): value is CaseActivityPageResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CaseActivityPageResponseFromJSON(json: any): CaseActivityPageResponse {
    return CaseActivityPageResponseFromJSONTyped(json, false);
}

export function CaseActivityPageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseActivityPageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CaseActivityPageFromJSON(json['data']),
    };
}

export function CaseActivityPageResponseToJSON(json: any): CaseActivityPageResponse {
    return CaseActivityPageResponseToJSONTyped(json, false);
}

export function CaseActivityPageResponseToJSONTyped(value?: CaseActivityPageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CaseActivityPageToJSON(value['data']),
    };
}

